module.exports = __webpack_public_path__ + "static/media/teamring.ccc0321d.png";